import { Button } from "primereact/button";


export const useActionsHook = (actions, type) => {

	function renderButton(params) {
		return <Button
			icon={"pi pi-trash"}
			size="small"
			style={{ width: "28px", height: "28px", fontSize: "8px", padding: "2px", fontWeight: 300 }}
			rounded
			text
			raised
			severity={"secondary"}
			{...params}
		/>
	}

	const columnBody = (row, field) => {
		if (type == "") {

		}

		return <div className="row-actions">
			{
				actions.map((el) => {
					const onClick = (e) => {
						el.onClick(e, row, field)
					}
					return renderButton({ ...el, onClick: onClick })
				})
			}
		</div>;
	}

	return {
		body: columnBody,
		header: "Actions"
	}
}